require("slick-carousel");

(function() {
    $("[js-slick-testimonials]").slick({
        infinite: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 3000,
        adaptiveHeight: true
    });
})();
